import React, {useEffect, useState} from 'react';
import { Box,   } from '@mui/material';
import PageContent from './partials/PageContent'
import PageHeader from './partials/PageHeader'
import SEO from '../../common/SEO';
//import image from '../../../assets/images/soluciones_discovery_data.png';
import AOS from 'aos';
import { getPageSolutionDiscoveriesData } from "../../../services/pages";
import Preloader from '../../common/Preloader'; 

const PageDiscoverySolution = () => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
  
  const [pageData, setPagesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pageResponse,] = await Promise.all([ getPageSolutionDiscoveriesData(), ]);          
        setPagesData(pageResponse || {});
      } catch (error) {
        console.error("Error fetching data:", error.response || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) { return <Preloader />; }

  const { title, description, content, image } = pageData.page_discovery;

  return (
  <Box className="solution-page" id="page-discovery">
    <SEO 
      title="Discovery Tecnológico para turismo | Diagnóstico y roadmap digital — E2E"
      description="Identificamos oportunidades de innovación y eficiencia: análisis de procesos, evaluación de sistemas y roadmap tecnológico para empresas de travel."
    />
    <PageHeader 
      title={title} 
      next={null}
      hrefNext={null} 
      prev="Automatización Robótica de Procesos (RPA)"
      hrefPrev="/solutions/automation" 
    />
    <PageContent 
      content={content} 
      title={title} 
      description={description} 
      image={image}
    /> 
    {/* <Box className="solution-page-content">
      <Container maxWidth="lg">
        <Grid data-aos="fade-up" container spacing={1}>
          <Grid size={{ xs: 12, md: 6 }}>
            <PageContent content={ 
              <>

              <div className="destacado">
                <p><strong>¿Qué es el Servicio de Discovery Tecnológico?</strong>   <br /> 
                    El Servicio de Discovery Tecnológico es un enfoque estratégico diseñado para identificar las mejores oportunidades de innovación y mejora operativa en tu negocio.
                    <br />
                    Analizamos tus procesos, evaluamos tus sistemas actuales y recomendamos soluciones tecnológicas que lo optimicen, desde la experiencia del cliente hasta la eficiencia operativa.
                    </p>
              </div>
                              
                <h3><span className="icon icon-places"></span> ¿Qué áreas abarcamos?</h3>

                <ol>
                  <li>
                    <strong>Automatización de Procesos Clave (KPA):</strong>
                    <ul>
                      <li>Detección de tareas repetitivas y susceptibles a automatización.</li>
                      <li>Propuestas de RPA e inteligencia artificial para agilizar operaciones.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Optimización de Experiencia del Cliente:</strong>
                    <ul>
                      <li>Recomendaciones para personalización de ofertas mediante IA y análisis de datos.</li>
                      <li>Soluciones para mejorar la interacción con clientes (chatbots, asistentes virtuales, apps móviles).</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Integración de Sistemas y Datos:</strong>
                    <ul>
                      <li>Identificación de mejoras en la conectividad entre plataformas (GDS, sistemas de reservas, CRM, Backoffice).</li>
                      <li>Estrategias para implementar plataformas centralizadas que consoliden datos de manera eficiente.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Implementación de verticales: (producto propio + consolidado)</strong>
                    <ul>
                      <li>Vuelos</li>
                      <li>Hoteles</li>
                      <li>Trenes</li>
                      <li>Autos</li>
                      <li>Asistencia al Viajero</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Seguridad y Cumplimiento:</strong>
                    <ul>
                      <li>Diagnóstico de seguridad cibernética y cumplimiento con normativas como PCI DSS o GDPR.</li>
                      <li>Propuestas de mejoras para la protección de datos y transacciones seguras.</li>
                    </ul>
                  </li>
                </ol>

                <h3><span className="icon icon-cogs"></span> ¿Cómo funciona el Servicio de Discovery?</h3>

                <ol>
                  <li>
                    <strong>Diagnóstico inicial:</strong>
                    <ul>
                      <li>Entrevistas con stakeholders clave.</li>
                      <li>Revisión de sistemas actuales y desafíos operativos.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Análisis de oportunidades:</strong>
                    <ul>
                      <li>Priorización de áreas de mejora según impacto en ingresos, costos y satisfacción del cliente.</li>
                      <li>Benchmarking con las mejores prácticas de la industria.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Diseño de roadmap tecnológico:</strong>
                    <ul>
                      <li>Creación de un plan estratégico que incluye soluciones específicas, estimaciones de ROI y plazos sugeridos.</li>
                      <li>Identificación de socios tecnológicos o herramientas clave.</li>
                    </ul>
                  </li>
                </ol>

                <h3><span className="icon icon-hand-coin"></span> Beneficios del Servicio de Discovery Tecnológico</h3>

                <ul>
                  <li><strong>Visión Integral:</strong> Explora oportunidades en todas las áreas clave de tu operación.</li>
                  <li><strong>Enfoque Personalizado:</strong> Soluciones adaptadas a tus necesidades, objetivos y presupuesto.</li>
                  <li><strong>Estrategia Basada en Datos:</strong> Toma decisiones informadas con el respaldo de análisis profesionales.</li>
                  <li><strong>Preparación para el Futuro:</strong> Diseña un camino claro hacia la digitalización y la competitividad.</li>
                </ul>              
               
                </>

            } />   

            <Button data-aos="fade-up" startIcon={<ArrowForwardIcon />}  variant="contained" color="primary" component={Link} to="/contact" >
                Solicita una Demostración
            </Button>     
          
          </Grid>
        </Grid>
        <Box data-aos="fade-left" data-aos-delay="300" className='absolute-image' component="img" src={image} alt="End to end Aéreos" />
      </Container>
    </Box> */}
  </Box>)
}

export default PageDiscoverySolution;